module.exports = __webpack_public_path__ + "img/icon_compressed_file.ab5370fc.svg";